"use client";

import * as React from "react";
import {
  Text,
  SectionCard,
  CardTitle,
  CardDescription,
  Section,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Button,
  Input,
  Label,
} from "@/src/components";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsPopover() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Popover
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            Displays floating content when triggered, useful for additional information or actions.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/popover" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Example</CardTitle>
              <CardDescription>A popover with form content</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <Popover>
            <PopoverTrigger asChild>
              <Button variant="outline">Open Popover</Button>
            </PopoverTrigger>
            <PopoverContent className="w-80">
              <div className="grid gap-4">
                <div className="space-y-2">
                  <h4 className="font-medium leading-none">Dimensions</h4>
                  <p className="text-sm text-muted-foreground">
                    Set the dimensions for the layer.
                  </p>
                </div>
                <div className="grid gap-2">
                  <div className="grid grid-cols-3 items-center gap-4">
                    <Label htmlFor="width">Width</Label>
                    <Input id="width" defaultValue="100%" className="col-span-2 h-8" />
                  </div>
                  <div className="grid grid-cols-3 items-center gap-4">
                    <Label htmlFor="height">Height</Label>
                    <Input id="height" defaultValue="25px" className="col-span-2 h-8" />
                  </div>
                </div>
              </div>
            </PopoverContent>
          </Popover>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Components</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Component</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">Popover</td>
                <td className="py-2 text-muted-foreground">Root component managing state</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">PopoverTrigger</td>
                <td className="py-2 text-muted-foreground">Element that opens the popover</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">PopoverContent</td>
                <td className="py-2 text-muted-foreground">The floating content container</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
